module.exports = __webpack_public_path__ + "static/media/Maven_6621.2157c81f.jpg";